import { ListeTable } from '@mairistem/liste';

type ArretesJournaliersListeTableHeaderProps = {
  [key: string]: any;
};

const ArretesJournaliersListeTableHeader = (props: ArretesJournaliersListeTableHeaderProps) => {
  const { ...rest } = props;

  return (
    <>
      <ListeTable.Column {...rest} name="libelle" verticalAlign="middle">
        Libellé
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="date" style={{ width: 150 }} verticalAlign="middle">
        Date d&apos;édition
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="heure" style={{ width: 100 }} verticalAlign="middle">
        Heure
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="montantTotal"
        style={{ width: 140 }}
        verticalAlign="middle"
      >
        Montant
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="document" style={{ width: 120 }} verticalAlign="middle">
        Document
      </ListeTable.Column>
    </>
  );
};

export default ArretesJournaliersListeTableHeader;
